module.exports = __webpack_public_path__ + "static/media/thermo.fa2acf17.jpg";